import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";

const OrderCodeCopy = ({ key, code }) => {
  return (
    <span key={key} className="d-flex align-items-center gap-1 text-info">
      {code}
      <Button
        id={`order_code_copy_${key}`}
        size="sm"
        color=""
        className="bg-light"
        onClick={e => navigator.clipboard.writeText(code)}
      >
        <i className="far fa-copy fa-md text-secondary" />
      </Button>
      <UncontrolledTooltip placement="top" target={`order_code_copy_${key}`}>
        Copy
      </UncontrolledTooltip>
    </span>
  );
};

export default OrderCodeCopy;
